import Vue from 'vue'
import SecureLS from 'secure-ls';


export default {
	SecureLocalStorage: null,
	validateMyKad(mykad) {

		var response = {
			gender: null,
			dateofbirth: null
		};

		if (mykad != "" && mykad.length == 12) {

			var head = mykad.substring(0, 6);
			var day = head.substring(4, 6);
			var month = head.substring(2, 4);
			var parseYear = head.substring(0, 2);

			var currentDate = new Date();
			var currentYear = currentDate.getFullYear();
			var year = parseInt(parseYear) + 1900;

			if ((parseInt(currentYear) - parseInt(year)) > 100) {
				year = parseInt(parseYear) + 2000;
			}

			var lastDigit = mykad.substring(11, 12);
			var gender = parseInt(lastDigit) % 2 == 0 ? "female" : "male";
			response.gender = gender;

			if (month <= 12 && day <= 31) {
				var validDate = new Date(year + "-" + month + "-" + day);
				if (
					validDate.getMonth() + 1 == parseInt(month) &&
					validDate.getDate() == parseInt(day)
				)
					response.dateofbirth = day + "/" + month + "/" + year;
			}
		}
		return response;
	},
	ShowLoader: function () {
		return true
	},
	ToYYYYMMDD: function (value) {

		if (!value)
			return;

		if (String(value).indexOf('/') == -1) {
			let newvalue = new Date(value);
			value = newvalue.getFullYear() + '/' + (newvalue.getMonth() + 1) + '/' + newvalue.getDate();
			return value;
		}

		var pcs = value.split('/');
		var year = pcs[2].split(' ');
		var birthDateNew = year[0] + '-' + pcs[1] + '-' + pcs[0];
		return birthDateNew
	},

	getMonth: function () {
		var currentmonth = ((new Date()).getMonth() + 1).toString();
		currentmonth = currentmonth.length == 1 ? `0${currentmonth}` : currentmonth;
		return currentmonth;
	},
	getDay: function () {
		var currentDay = ((new Date()).getDate()).toString();
		currentDay = currentDay.length == 1 ? `0${currentDay}` : currentDay;
		return currentDay;
	},
	restSession: function () {
		var currentdate = new Date();
		var currentLoggedDate = currentdate.getFullYear() + "-" + (currentdate.getMonth() + 1) + "-" + currentdate.getDate() + " " + currentdate.getHours() + ":" + currentdate.getMinutes() +
			":" + currentdate.getSeconds();
		commonService.setStorage("loggedDateTime", currentLoggedDate.toString());
	},
	removeToken: function () {
		this.removeStorage('token');
	},
	isAuthenticated: function () {
		return this.getStorage('token') !== '';
	},
	isCompleteRegistration: function () {
		if (this.getStorage('token') !== '') {
			if (this.getStorage('completeRegistration') === false) {
				return {
					path: 'completeregistration'
				}
			}
			if (this.getStorage('forceChangePhoneNumber') === true) {
				return {
					path: 'changephone'
				}
			}
			return true;
		} else {
			return {
				path: 'account/login',
				query: {
					redirect: to.fullPath
				}
			}
		}
	},
	destroyStorage: function () {
		this.removeStorage('token')
		this.removeStorage('name')
		this.removeStorage('refreshToken')
		this.removeStorage('completeRegistration');
		this.removeStorage('phoneNumberConfirmed');
		this.removeStorage('countryFlag');
		this.removeStorage('lastLoginDate');
		this.removeStorage('userKycStatus');
		this.removeStorage('ekycEnable');
		this.removeStorage("loggedDateTime");
		this.removeStorage('emailAddressConfirmed');
		this.removeStorage('forceChangePhoneNumber');
		this.removeStorage('forceChangePassword');
		this.removeStorage('isVerifiedEKYCUser');
		this.removeStorage('isUnVerifiedKYCUser');
		this.removeStorage('userDetail');
		this.removeStorage('IsRequiredEkycBankDetail');
		this.removeStorage('IsCompleteForm');
		this.removeStorage('EUIdleTime');
		this.removeStorage('GMapAPIKey_JS');
		window.sessionStorage.clear();
	},
	logOut: function (isAccessDenied) {

		if (isAccessDenied === undefined) {
			window.Vue.$http.get("account/logout");
		}
		this.destroyStorage();
		if (window.__sessionInterval != null)
			clearInterval(window.__sessionInterval)
	
		window.Vue.$router.push({ name: 'Login', params: { isLoggedOut: true } })
	},
	logOutAfterAccountDeletion: function(){
		window.Vue.$http.get("account/logout");
		this.destroyStorage();
		if (window.__sessionInterval != null)
			clearInterval(window.__sessionInterval)
	
		window.Vue.$router.push('/home');
	},
	getAuthToken: function () {
		return this.getStorage('token');
	},
	getUserInfo: function () {
		return {
			Name: this.getStorage('name'),
			PhoneNumberConfirmed: this.getStorage('phoneNumberConfirmed'),
			EmailAddressConfirmed: this.getStorage('emailAddressConfirmed'),
			CompleteRegistration: this.getStorage('completeRegistration'),
			EkycEnable: this.getStorage('ekycEnable'),
			UserKycStatus: this.getStorage('userKycStatus'),
			CountryFlag: this.getStorage('countryFlag'),
			LastLoginDate: this.getStorage('lastLoginDate'),
			IPAddress: this.getStorage("ipAddress"),
			IsVerifiedEKYCUser: this.getStorage("isVerifiedEKYCUser"),
			IsUnVerifiedKYCUser: this.getStorage("isUnVerifiedKYCUser"),
			ForceChangePhoneNumber: this.getStorage('forceChangePhoneNumber'),
			ForceChangePassword: this.getStorage('forceChangePassword'),
			EnableLimitRequest: this.getStorage("enableLimitRequest"),
		}
	},

	getUserAddressValidation: function () {
		return JSON.parse(this.getStorage('addressValidation'));
	},
	getEmployeeIndustryCheck: function () {
		return JSON.parse(this.getStorage('employeeIndustryCheck'));
	},
	getBeneOwnerDetail: function () {
		return JSON.parse(this.getStorage('BeneOwnerDetail'));
	},
	getUserDetailInformation: function () {
		return JSON.parse(this.getStorage('userDetail'));

	},
	getBaseUrl: function (url) {
		if (window.location.hostname == 'localhost')
			return 'http://localhost:42621/api/' + url;
		  //return 'https://demo.eremit.com.my/api/' + url;
			//return 'https://demo.eremit.com.my/api/' + url;
		else
			return '/api/' + url;
	},
	jsonStringify: function (obj) {
		return JSON.stringify(obj)
	},
	jsonParse: function (str) {
		return JSON.parse(str)
	},
	gridListFilter: function (url) {
		var _this = this;
		var dataSource = url;
		if (typeof url === "string") {
			dataSource = new kendo.data.DataSource({
				transport: {
					read: {
						url: _this.getBaseUrl(url),
						contentType: "application/json; charset=UTF-8",
						type: "GET",
						beforeSend: function (xhr) {
							xhr.setRequestHeader("DeviceType", "Web");
							xhr.setRequestHeader("X-Token", _this.getAuthToken());
						}
					}
				},
				requestStart: function (e) {
					Vue.prototype.$Progress.start();
				},
				requestEnd: function () {
					Vue.prototype.$Progress.finish();
				}
			});
		}
		var defaultOptions = {
			dataSource: dataSource,
			optionLabel: "--Select--",
			dataTextField: "Text",
			dataValueField: "Id"

		}

		return {
			ui: function (element) {
				element.kendoDropDownList(defaultOptions);
			},
			operators: {
				string: {
					eq: "Equal to"
				}
			}
		}
	},
	//slInstance: (this.SecureLocalStorage == null ? new SecureLS({ encodingType: 'rc4', isCompression: true }) : this.SecureLocalStorage),
	slInstance: new SecureLS({
		encodingType: 'rc4',
		isCompression: true
	}),
	setStorage: function (key, value) {
		console.log(key)
		if ((typeof key) == "object" && value === undefined) {

			Object.keys(key).forEach((v) => {
				this.slInstance.set(v, key[v]);
			});
		} else
			this.slInstance.set(key, value);
	},
	getStorage: function (key) {
		try {
			return this.slInstance.get(key);
		} catch (ex) {
			window.localStorage.clear();
			window.location.href = '/account/login';

		}

	},
	removeStorage: function (key) {
		if (key === undefined)
			this.slInstance.removeAll();
		else
			this.slInstance.remove(key);
	}
}
